import {SERVER_MENU_SYNC_URL, SERVER_URL} from './API_CONSTANTS';

export const LOCATIONS_NOTIFICATIONS_DATA = (id) =>
  `${SERVER_URL}/locations-management/configurations/${id}`;

export const PUBLISH_BOT_STATUS = (menuConfigId) =>
  `${SERVER_MENU_SYNC_URL}/sync-bot/tasks/status/${menuConfigId}`;
